import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ShowModalTerminosyCondicionesResponse } from "../interfaces/showModalTerminosYCondiciones.interface";

@Injectable({ providedIn: 'root' })
export class ShowModalTerminosyCondicionesService {
  private apiUrl = 'https://bk-mkp.da-pw.mx/api/termsAndConditions/getDate';
  http = inject(HttpClient);

  showModal(): Observable<ShowModalTerminosyCondicionesResponse> {
    return this.http.get<ShowModalTerminosyCondicionesResponse>(this.apiUrl);
  }
}
